import React, { useCallback } from 'react'
import { FiPlayCircle } from 'react-icons/fi'
import { useSelector } from 'react-redux'

import PropTypes from 'prop-types'

import { Button } from '~/components/Buttons'
import { Spinner } from '~/components/Spinner'

import usePromotion from '../../hooks/usePromotion'

const ReactiveButton = ({ promotion, menuItem = false }) => {
  const { handleReactivePromotion } = usePromotion()

  const { loadingSaving: loading } = useSelector(state => state.promotional)

  const handleSubmit = useCallback(() => {
    const data = {
      promotion
    }

    handleReactivePromotion(data)
  }, [handleReactivePromotion, promotion])

  return (
    <>
      {menuItem ? (
        <button type="button" onClick={handleSubmit} className="success">
          {loading ? <Spinner /> : <FiPlayCircle />} <span>Reativar</span>
        </button>
      ) : (
        <Button
          text="Reativar"
          type="button"
          template="secondary"
          size="small"
          iconLeft={loading ? <Spinner /> : <FiPlayCircle />}
          customWidth="auto"
          onClick={handleSubmit}
        />
      )}
    </>
  )
}

export default ReactiveButton

ReactiveButton.propTypes = {
  promotion: PropTypes.shape({}).isRequired,
  menuItem: PropTypes.bool
}

ReactiveButton.defaultProps = {
  menuItem: false
}
